// extracted by mini-css-extract-plugin
export var dividerLine = "_9d-3";
export var itemImage = "_9d-9";
export var lightDivider = "_9d-4";
export var modalContent = "_9d-5";
export var modalContentCompact = "_9d-6";
export var productCard = "_9d-a";
export var productImage = "_9d-b";
export var productImageCompact = "_9d-7";
export var productImagePlaceholder = "_9d-c";
export var productImagePlaceholderCompact = "_9d-8";
export var progressBarBackground = "_9d-1";
export var progressBarContainer = "_9d-0";
export var progressBarFill = "_9d-2";